import { SVGProps } from 'react';

export const Vendors = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.479 5.57725L11.479 0.12225C11.181 -0.04075 10.819 -0.04075 10.521 0.12225L0.521 5.57725C0.2 5.75125 0 6.08825 0 6.45425V7.86125C0 8.41325 0.448 8.86125 1 8.86125H2V16.8612C2 17.4132 2.448 17.8612 3 17.8612H5V9.86125H17V17.8612H19C19.552 17.8612 20 17.4132 20 16.8612V8.86125H21C21.552 8.86125 22 8.41325 22 7.86125V6.45425C22 6.08825 21.8 5.75125 21.479 5.57725"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 13.8613H15V11.8613H7V13.8613Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 17.8613H15V15.8613H7V17.8613Z"
      fill="currentColor"
    />
  </svg>
);
